import { Routes } from '@angular/router';
import { PageKey } from '../../../../shared/services/page/models/page.key';

export const usersRoute: Routes = [{
  path: '',
  loadComponent: () => import('./users.component').then(m => m.UsersComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./list/list.component').then(m => m.ListComponent),
      data: {
        title: 'Listar Usuários',
        key: PageKey.USERS,
        fullscreen: true
      },
    },
    {
      path: 'list',
      loadComponent: () => import('./list/list.component').then(m => m.ListComponent),
      data: {
        title: 'Listar Usuários',
        key: PageKey.USERS,
        fullscreen: true
      },
    },
    {  
      path: 'create', 
      loadComponent: () => import('./create/create.component').then(m => m.CreateUsersComponent),
      data: {
        title: 'Criar Usuário',
        key: PageKey.USERS,
        fullscreen: true
      }
    },
    {
      path: 'update/:id',
      loadComponent: () => import('./create/create.component').then(m => m.CreateUsersComponent),
      data:{
        title: 'Editar Usuário',
        key: PageKey.USERS,
        fullscreen: false
      }
    }
  ]
}];
